import { downloadFileFromGet } from './downloads'

const downloadBreachesReport = async () =>
  downloadFileFromGet({ endpoint: '/api/uBreach/breaches.xlsx', file: 'breaches{{ts}}.xlsx' })

export default downloadBreachesReport
